// src/utils/beritaParse.js

export const stripHtml = (html) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || '';
};

// ---

export const extractObituaryDetails = (obituary) => {
    const {
        berita
    } = obituary;
    if (!berita) {
        return {
            nama: 'Nama tidak diketahui',
            wafat: '',
            usia: '',
            disemayamkan: '',
            keterangan: ['Tuhan Yesus memberi kekuatan & penghiburan bagi keluarga yang berduka']
        };
    }

    const details = {
        judul: 'Berita Duka',
        nama: '',
        wafat: '',
        usia: '',
        disemayamkan: '',
        keterangan: []
    };

    const cleanedBerita = stripHtml(berita);
    const lines = cleanedBerita.split('\n').map(line => line.trim()).filter(line => line.length > 0);

    const allExtractedTexts = new Set();

    // Ekstrak nama
    const strongTagRegex = /<strong>(.*?)<\/strong>/g;
    const strongMatch = strongTagRegex.exec(berita);
    if (strongMatch && strongMatch[1]) {
        details.nama = stripHtml(strongMatch[1]).trim();
        allExtractedTexts.add(details.nama);
    } else {
        const nameLine = lines.find(line =>
            line.toLowerCase().includes('alm.') ||
            line.toLowerCase().includes('almh.') ||
            line.toLowerCase().includes('atas berpulangnya') ||
            line.toLowerCase().includes('telah meninggal dunia:')
        );
        if (nameLine) {
            let extractedName = nameLine;
            const nameRegex = /(?:alm\. |almh\. |atas berpulangnya |telah meninggal dunia: )?([A-Z0-9\s.-]+?)(?: ke rumah bapa di surga)?$/i;
            const match = nameLine.match(nameRegex);
            if (match && match[1]) {
                extractedName = match[1].trim();
            }
            details.nama = extractedName;
            allExtractedTexts.add(details.nama);
        } else {
            const firstLine = lines[0];
            if (firstLine && firstLine.length < 50 && !firstLine.toLowerCase().includes('berita duka')) {
                details.nama = firstLine;
                allExtractedTexts.add(details.nama);
            } else {
                details.nama = 'Nama tidak diketahui';
            }
        }
    }

    // Ekstrak detail lainnya
    lines.forEach(line => {
        const lowerLine = line.toLowerCase();
        if ((lowerLine.includes('wafat') || lowerLine.includes('meninggal') || lowerLine.includes('pada hari')) && !details.wafat) {
            details.wafat = line.trim();
            allExtractedTexts.add(details.wafat);
        } else if (lowerLine.includes('usia') && !details.usia) {
            details.usia = line.trim();
            allExtractedTexts.add(details.usia);
        } else if ((lowerLine.includes('disemayamkan') || lowerLine.includes('alamat rumah duka')) && !details.disemayamkan) {
            details.disemayamkan = line.trim();
            allExtractedTexts.add(details.disemayamkan);
        }
    });

    // Ekstrak keterangan
    const irrelevantPhrases = [
        'berita duka',
        'telah meninggal dunia',
        'turut berduka cita',
        'mohon dukungan doa',
        'gpip',
        'alamat rumah duka',
        'ibadah penghiburan',
        'ibadah penglepasan',
    ];

    const parsedKeterangan = lines.filter(line => {
        const lowerLine = line.toLowerCase();
        const isExtracted = [...allExtractedTexts].some(extractedText => extractedText.trim() === line.trim());
        const isIrrelevant = irrelevantPhrases.some(phrase => lowerLine.includes(phrase));
        const nameContainsLine = details.nama !== 'Nama tidak diketahui' && line.includes(details.nama);

        return !isExtracted && !isIrrelevant && !nameContainsLine;
    });

    details.keterangan = [...new Set(parsedKeterangan)];

    // Logika utama untuk keterangan
    const hasKeteranganFromBackend = details.keterangan.some(line =>
        line.toLowerCase().includes('almarhum merupakan') ||
        line.toLowerCase().includes('mohon dukungan doa')
    );

    if (!hasKeteranganFromBackend) {
        details.keterangan = ['Tuhan Yesus memberi kekuatan & penghiburan bagi keluarga yang berduka'];
    }

    return details;
};